export default __webpack_public_path__ + "static/media/videoThumbnail.65958e73.png";